import { findConnectionAppBySlug } from '@/data/connectionAppsCatalog'
import { connectionUiState } from '@/features/integrations'
import { titleFromSlug } from './titleFromSlug.js'

/**
 * The static catalog is still consulted for branding (icon, nicer title); the
 * connection itself comes from the provider.
 *
 * There is deliberately no `email`: the provider's connection view does not
 * return one, so the field was always an empty string rendering an empty
 * subtitle. `uiState` takes its place — it is the thing the row actually has
 * to show.
 *
 * @param {{ id: string, toolkitSlug?: string, status?: string, isDisabled?: boolean }} row
 */
export function resolveConnectionRow(row) {
  const slug = String(row.toolkitSlug || '')
    .trim()
    .toLowerCase()
  const catalog = slug ? findConnectionAppBySlug(slug) : undefined
  return {
    id: String(row.id),
    toolkitSlug: slug,
    title: catalog?.title || titleFromSlug(slug),
    iconUrl: catalog?.icon ?? null,
    account: row.displayLabel ?? null,
    status: row.status ?? null,
    isDisabled: Boolean(row.isDisabled),
    approvedCount: row.approvedCount ?? null,
    requiresApproval: row.requiresApproval ?? null,
    permissionsStatus: row.permissionsStatus ?? 'unavailable',
    uiState: connectionUiState({ status: row.status, is_disabled: row.isDisabled }),
  }
}
